import { EditRq } from "./trade.request.data";
import { DataService } from "../services/data/data.service";
import { Workspace } from "./workspace.data";
import { EventType } from "../components/achart/achart.annotation.tools";
import { invertColor, AChartComponent } from "../components/achart/achart.component";
import { Ticket } from '../components/tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import {IOrdersData} from "../interfaces/service.response";
import { version } from 'punycode';

export class tradingLines {
    constructor(protected dataService: DataService, protected workspace: Workspace) {}

    private _pipValue: number = 0.01;
    public get pipValue(): number {
        return this._pipValue;
    }
    public set pipValue(value: number) {
        this._pipValue = value;
    }

    private _tempTradeData: IOrdersData | null = null;
    public get tempTradeData(): IOrdersData | null {
        return this._tempTradeData;
    }
    public set tempTradeData(value: IOrdersData | null) {
        this._tempTradeData = value;
    }

    private _chartObj: any;
    set chart(v: anychart.charts.Stock) {
        this._chartObj = v;
    }

    get chart(): anychart.charts.Stock {
        return <anychart.charts.Stock>this._chartObj;
    }

    private _allowRemove: boolean = true;
    public get allowRemove(): boolean {
        return this._allowRemove;
    }
    public set allowRemove(value: boolean) {
        this._allowRemove = value;
    }

    private _isMobile: boolean = false;
    public get isMobile(): boolean {
        return this._isMobile;
    }
    public set isMobile(value: boolean) {
        this._isMobile = value;
        if(value==true)
        {
            this.showTradeNumbers = false
            this.showPriceValuess = false
        }
        
    }


    private _showTradeNumbers: boolean = true;
    public get showTradeNumbers(): boolean {
        return this._showTradeNumbers;
    }
    public set showTradeNumbers(value: boolean) {
        this._showTradeNumbers = value;
    }
    private _showPriceValuess: boolean = true;
    public get showPriceValuess(): boolean {
        return this._showPriceValuess;
    }
    public set showPriceValuess(value: boolean) {
        this._showPriceValuess = value;
    }

    public marketPriceLine: anychart.core.annotations.HorizontalLine | undefined;
    public marketStopLine: anychart.core.annotations.HorizontalLine | undefined;
    public marketLimitLine: anychart.core.annotations.HorizontalLine | undefined;

    public marketPriceMarker: anychart.core.axisMarkers.Text | undefined;
    public marketStopMarker: anychart.core.axisMarkers.Text | undefined;
    public marketLimitMarker: anychart.core.axisMarkers.Text | undefined;

    public marketPriceMarkerInfo: anychart.core.axisMarkers.Text | undefined;
    public marketStopMarkerInfo: anychart.core.axisMarkers.Text | undefined;
    public marketLimitMarkerInfo: anychart.core.axisMarkers.Text | undefined;

    public marketPriceLineIndex: number = -1;
    public marketStopLineIndex: number = -1;
    public marketLimitLineIndex: number = -1;

    public marketColor: string = "#fefefe";
    public lsColor: string = "#2549f5";

    public stopColor = "#e9b500";
    public limitColor = "#b102c1";

    private _allowDraw: boolean = true;
    public get allowDraw(): boolean {
        return this._allowDraw;
    }
    public set allowDraw(value: boolean) {
        this._allowDraw = value;
    }

    



    drawTradeLines(tradeData: IOrdersData | null) {
        if (!this.allowRemove) {
            return;
        }
        if (!this.allowDraw) {
            return;
        }

        let drawingLineStyle = "5 2";

        if(this.isMobile)
        {
           // drawingLineStyle = "";
        }

        if(tradeData==null)
        {
            return;
        }
         
        this.marketColor = invertColor(this.parentBackgrounColor,true);
          
        if (this.tempTradeData === null) return;

    //    this.removeTradeLines();
    if(!this.marketPriceLine)
    {

    
            this.marketPriceLine = this.chart
            .plot(0)
            .annotations()
            .horizontalLine({
                valueAnchor: tradeData.EntryPrice
            });

            this.marketPriceLine.zIndex(10000);
            this.marketPriceLine.normal().stroke(this.marketColor, 2, drawingLineStyle);
            this.marketPriceLine.hovered().stroke(this.marketColor, 2,drawingLineStyle);
            this.marketPriceLine.selected().stroke(this.marketColor, 4, drawingLineStyle);
        }

        if((tradeData.EditRq.StopPrice>0 || tradeData.Stop >0) && !this.marketStopLine)
        {
            this.marketStopLine = this.chart
                .plot(0)
                .annotations()
                .horizontalLine({
                    valueAnchor: tradeData.EditRq.StopPrice || (tradeData.Stop && tradeData.Stop) || 0
                });

            this.marketStopLine.zIndex(10001);

            this.marketStopLine.normal().stroke(this.stopColor, 2, drawingLineStyle);
            this.marketStopLine.hovered().stroke(this.stopColor, 2, drawingLineStyle);
            this.marketStopLine.selected().stroke(this.stopColor, 4, drawingLineStyle);
        }

        if((tradeData.EditRq.LimitPrice>0 || tradeData.Limit>0) && !this.marketLimitLine)
        {
            this.marketLimitLine = this.chart
                .plot(0)
                .annotations()
                .horizontalLine({
                    valueAnchor:  tradeData.EditRq.LimitPrice || (tradeData.Limit && tradeData.Limit) || 0
                });

            this.marketLimitLine.normal().stroke(this.limitColor, 2, drawingLineStyle);
            this.marketLimitLine.hovered().stroke(this.limitColor, 2, drawingLineStyle);
            this.marketLimitLine.selected().stroke(this.limitColor, 4, drawingLineStyle);

            this.marketLimitLine.zIndex(10002);
        }

        




        this.chart.listen(EventType.ANNOTATION_SELECT, (e: any) => {
            if (e.annotation == this.marketPriceLine) {
                e.annotation.unselect();
            }
        });
        //       this.tempTradeData=null;
        // this.workspace.get
    }


    private _parentBackgrounColor: string = "#ffffff";
    public get parentBackgrounColor (): string {
        return this._parentBackgrounColor;
    }
    public set parentBackgrounColor ( value: string ) {
        this._parentBackgrounColor = value;
    }

    public backgroundColor(color:string)
    {
        this.parentBackgrounColor = color;
    }



    public get marketLineLabel()
    {
        if(this.tempTradeData!=null)
        return "#" + this.tempTradeData.Ticket + " " + this.tempTradeData.Type;
    }


    public get stopLineLabel()
    {
        if(this.tempTradeData!=null)
        return "#" + this.tempTradeData.Ticket + " Stop";
    }

    public get limitLineLabel()
    {
        if(this.tempTradeData!=null)
        return "#" + this.tempTradeData.Ticket + " Limit";
    }

    public removeTradeLines() {
        if (!this.allowRemove) {
            return;
        }


        if (this.marketPriceMarker) {
            this.marketPriceMarker.enabled(false);
            this.marketPriceMarker.value(-100)
            delete this.marketPriceMarker;
        }

        if (this.marketLimitMarker) {
            this.marketLimitMarker.enabled(false);
            this.marketLimitMarker.value(-100)
            delete this.marketLimitMarker;
        }

        if (this.marketStopMarker) {
            this.marketStopMarker.enabled(false);
            this.marketStopMarker.value(-100);
            delete this.marketStopMarker;
        }



        if (this.marketPriceMarkerInfo) {
            this.marketPriceMarkerInfo.enabled(false);
            delete this.marketPriceMarkerInfo;
        }

        if (this.marketLimitMarkerInfo) {
            this.marketLimitMarkerInfo.enabled(false);
            delete this.marketLimitMarkerInfo
        }

        if (this.marketStopMarkerInfo) {
            this.marketStopMarkerInfo.enabled(false);
            delete this.marketStopMarkerInfo;
        }
        
        if (this.marketLimitLine) {
            //  this.marketLimitLine.textMarker.enabled(false)
          //  if(this.marketLimitLine!=undefined) this.marketLimitLine.valueAnchor(-100);

            this.chart
                .plot(0)
                .annotations()
                .removeAnnotation(this.marketLimitLine);
        }

        if (this.marketPriceLine) {
        //    if(this.marketPriceLine!=undefined)  this.marketPriceLine.valueAnchor(-100);
            this.chart
                .plot(0)
                .annotations()
                .removeAnnotation(this.marketPriceLine);
        }

        if (this.marketStopLine) {
        //    if(this.marketStopLine!=undefined)   this.marketStopLine.valueAnchor(-100);
            this.chart
                .plot(0)
                .annotations()
                .removeAnnotation(this.marketStopLine);
        }

       

        // const ann1 = this.chart.plot(0).annotations();
        // ann1.forEach(a => this.undecorateAnnotation(a));
    }

    public updateOrderEntry(e: any) {
        if (this.tempTradeData === null) return;

        this.pipsFactor = this.tempTradeData.Type == "Pending" ? 1 : -1;

        if (this.chart !== undefined) {
            let selectedAnnotation = this.chart
                .plot(0)
                .annotations()
                .getSelectedAnnotation();
            //console.log( e);
            console.log(this.tempTradeData);

            if (this.marketPriceLine == selectedAnnotation) {
                console.log("marketPriceLineIndex");
                this.tempTradeData.MarketPrice = e;
                this.updateOrder();
                // ;//selectedAnnotation.markers().anchor()
            }

            if (this.marketStopLine == selectedAnnotation) {
                console.log("marketStopLineIndex");
                this.tempTradeData.EditRq.StopPrice = e;
                this.updateOrder();
            }

            if (this.marketLimitLine == selectedAnnotation) {
                console.log("marketLimitLineIndex");
                this.tempTradeData.EditRq.LimitPrice = e;
                this.updateOrder();
            }
        }
    }


    public updateData(v: IOrdersData,  chartComponnet:AChartComponent)
    {

        this.removeTradeLines();
        this.drawTradeLines(this.tempTradeData);
        // this.tempTradeData = v;
        // if(this.marketStopLine)
        // {
        //     if(this.tempTradeData.Stop!=null)
        //     {
        //          this.marketStopLine.valueAnchor(this.tempTradeData.Stop);

        //          if( this.marketStopMarkerInfo)
        //          this.marketStopMarkerInfo.value(this.tempTradeData.Stop)

        //          if(this.marketStopMarker)
        //          this.marketStopMarker.value(this.tempTradeData.Stop)
        //     }
        //     else
        //     {

        //     }
           
        // }
        // else
        // {
        //     if((v.EditRq.StopPrice>0 || version.Stop >0) && !this.marketStopLine)
        //     {
        //         let drawingLineStyle = "5 2";

        //         this.marketStopLine = this.chart
        //             .plot(0)
        //             .annotations()
        //             .horizontalLine({
        //                 valueAnchor: v.EditRq.StopPrice || (v.Stop && v.Stop) || 0
        //             });
    
        //         this.marketStopLine.zIndex(10001);
    
        //         this.marketStopLine.normal().stroke(this.stopColor, 2, drawingLineStyle);
        //         this.marketStopLine.hovered().stroke(this.stopColor, 2, drawingLineStyle);
        //         this.marketStopLine.selected().stroke(this.stopColor, 4, drawingLineStyle);

        //         chartComponnet.decorateAnnotation(<any> this.marketStopLine);
        //     }
        // }
    }

    updateOrder() {
        if(this.tempTradeData)
        {
        let Req: EditRq = <any>this.tempTradeData.EditRq as EditRq;
        let currentAsk: number = this.getCurrentAskPrice();
        Req.StopPips = this.stopPips(this.tempTradeData, currentAsk);
        Req.LimitPips = this.limitPips(this.tempTradeData, currentAsk);

        this.dataService.sendRequest({ Cmd: DataService.TYPE_EDITTRADE, Data: Req });
        }
    }

    stopPips(tempTradeData: any, ask: number) {
        let countOfPips = Math.round((tempTradeData.EditRq.StopPrice - ask) / this.pipValue);

        if (tempTradeData.EditRq.Side == "Buy" && tempTradeData.EditRq.Type == "Market") {
            return -countOfPips;
        }

        if (tempTradeData.EditRq.Side == "Sell" && tempTradeData.EditRq.Type == "Pending") {
            return -countOfPips;
        }

        return countOfPips;
    }

    limitPips(tempTradeData: any, ask: number) {
        let countOfPips = Math.round((ask - tempTradeData.EditRq.LimitPrice) / this.pipValue);

        if (tempTradeData.EditRq.Side == "Buy" && tempTradeData.EditRq.Type == "Market") {
            return -countOfPips;
        }

        if (tempTradeData.EditRq.Side == "Sell" && tempTradeData.EditRq.Type == "Pending") {
            return -countOfPips;
        }

        return countOfPips;
    }

    private pipsFactor: number = -1;
    getCurrentAskPrice(): number {

        if( this.tempTradeData!=null)
        {
            let filterSymbol = this.workspace.boxes.filter(c => {
            if (this.tempTradeData!=null && c.Symbol == this.tempTradeData.Symbol) return c;
        });

        this.pipValue = filterSymbol[0].Pip;
        return filterSymbol[0].Ask;
        }

        return 0;
    }
}
